import { Either, LeftSide, RightSide } from "src/base/Either";
import {
  DataConnectRemoteDatasource,
  IDataConnectRemoteDatasource,
  ISyncSession,
} from "../datasources/dataConnectRemoteDataSource";

export interface IDataConnectRepository {
  createSyncSession(): Promise<Either<Error, ISyncSession>>;
  getSyncSessionStatus(syncSessionId: string): Promise<Either<Error, ISyncSession>>;
}

export class DataConnectRepository implements IDataConnectRepository {
  remoteDatasource: IDataConnectRemoteDatasource;

  constructor(remoteDatasource?: IDataConnectRemoteDatasource) {
    this.remoteDatasource = remoteDatasource || new DataConnectRemoteDatasource();
  }

  async createSyncSession(): Promise<Either<Error, ISyncSession>> {
    try {
      const syncSession = await this.remoteDatasource.createSyncSession();
      return RightSide(syncSession);
    } catch (error) {
      return LeftSide(error as Error);
    }
  }

  async getSyncSessionStatus(syncSessionId: string): Promise<Either<Error, ISyncSession>> {
    try {
      const syncSession = await this.remoteDatasource.getSyncSessionStatus(syncSessionId);
      return RightSide(syncSession);
    } catch (error) {
      return LeftSide(error as Error);
    }
  }
}
